import * as firebase from "firebase";

export default {
    state: {
        homeData: undefined,
        homeLoading: false,
        sendMsgLoading: false
    },
    getters: {
        getMainBannerData(state) {
            return state.homeData.mainBanner;
        },
        getExploreBannerData(state) {
            return state.homeData.exploreBanner;
        },
        homeLoading(state) {
            return state.homeLoading;
        },
        sendMsgLoading(state) {
            return state.sendMsgLoading;
        }
    },
    mutations: {
        setHomeData(state, payload) {
            state.homeData = payload;
        },
        setSendMsgLoading(state, payload) {
            state.sendMsgLoading = payload;
        },
        setHomeLoading(state, payload) {
            state.homeLoading = payload;
        }
    },
    actions: {
        sendMessageFromUser ({commit}, payload) {
            commit("setSendMsgLoading", true);
            firebase.firestore().collection("userMessages").doc()
                .set(payload)
                .then( () => {
                    commit("setSuccessMessage", "Thank you, message sent successfully.")
                    commit("setSendMsgLoading", false);
                })
                .catch( () => {
                    commit("setErrorMessage", "Error while sending messsage, please try again later.")
                    commit("setSendMsgLoading", false);
                })
        },
        fetchHomeData({commit}) {
            commit("setHomeLoading", true);
            firebase.database().ref("/home/").once("value")
                .then((data) => {
                    const homeData = data.val();
                    commit("setHomeData", homeData);
                    commit("setHomeLoading", false);
                })
                .catch((error) => {
                    commit("setErrorMessage", error.message);
                    commit("setHomeLoading", false);
                });
        }
    }
}